module.exports = __webpack_public_path__ + "media/images/trip_default_logo_db-541108d1.jpg";